import React, { useEffect, useState } from "react";
import { listarEmpresas } from "../services/api";
import { teclaAtiva } from "../utils/teclaAtiva";

// Cores dos selos vindos do backend (none|bad|mid|good|ra)
const SELO = {
  ra:   { txt: "Selo eaiRH", cls: "bg-green-100 text-green-800" },
  good: { txt: "Boa",        cls: "bg-blue-100 text-blue-800" },
  mid:  { txt: "Regular",    cls: "bg-yellow-100 text-yellow-800" },
  bad:  { txt: "Ruim",       cls: "bg-red-100 text-red-800" },
  none: { txt: "Sem nota",   cls: "bg-gray-100 text-gray-600" },
};

function corNota(score) {
  if (score >= 7) return "text-green-600";
  if (score >= 5) return "text-yellow-600";
  return "text-red-600";
}

export default function CompanyRanking({ onSelect }) {
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    listarEmpresas().then((e) => setEmpresas(e.slice(0, 5))).catch(() => setEmpresas([]));
  }, []);

  if (!empresas.length) return null;

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <h4 className="text-base font-semibold text-gray-900">Ranking de reputação</h4>
      <ul className="mt-4 space-y-2">
        {empresas.map((e) => {
          const selo = SELO[e.selo] || SELO.none;
          return (
            <li
              key={e.id}
              onClick={() => onSelect?.(e.id)}
              {...teclaAtiva(() => onSelect?.(e.id))}
              aria-label={`Ver reputação de ${e.nome}`}
              className="flex items-center gap-3 cursor-pointer rounded-xl border border-gray-100 p-2.5 hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <span className={`text-lg font-extrabold w-9 text-center ${e.selo === "none" ? "text-gray-300" : corNota(e.score)}`} title={e.selo === "none" ? "Reputação em formação" : `${e.score.toFixed(1)}/10`}>
                {e.selo === "none" ? "–" : e.score.toFixed(1)}
              </span>
              <div className="min-w-0 flex-1">
                <div className="font-medium text-gray-900 truncate">{e.nome}</div>
                <span className={`inline-block text-[11px] font-semibold rounded-full px-2 py-0.5 ${selo.cls}`}>
                  {e.classificacao}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
